import { Values } from 'ha/constants/Facilities';
import { TranslateFunc } from 'ha/i18n';

import { ListingAttributes } from '../types';

export function getBillsLabel(room: ListingAttributes, T: TranslateFunc) {
  const bills = [
    room.waterCostIncluded,
    room.gasCostIncluded,
    room.electricityIncluded,
    room.internetIncluded,
  ];

  if (bills.every(included => included === Values.Yes)) {
    return T('Bills Included');
  }

  if (bills.some(included => included === Values.Yes)) {
    return T('Some bills included');
  }

  return T('Bills Excluded');
}
